export const name = 'rnUser';
export default function rnUser($q, $log, rnHttp, rnRecordFactory, rnRecordCollectionFactory, rnSession) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const AAA_SERVICE_NAME = 'aaa';
  const ORG_USER_PATH = 'organizations/users/';
  const USER_CONTEXT_PATH = 'users/context/';
  const USER_ROLE_PATH = 'users/roles/';
  const USER_PATH = 'users/';

  let service = {
    getUserContext: getUserContext,
    getUserRoles: getUserRoles,
    getUserSystemRoles: getUserSystemRoles,
    getHmacSystemRoles: getHmacSystemRoles,
    getDeviceSystemRoles: getDeviceSystemRoles,
    getSelectedUserOrgRoles: getSelectedUserOrgRoles,
    getSelectedUserRoles: getSelectedUserRoles,
    saveUserRoles: saveUserRoles,
    removeUserRoles: removeUserRoles,
    removeUserAccount: removeUserAccount,
    deleteUser: deleteUser,
    updateUserProfile: updateUserProfile,
    getById: getById,
    getAll: getAll,
    validateUserToken: validateUserToken
  };

  return service;

  ////////////////

  function getById(id) {
    return doAaaGet(ORG_USER_PATH + id)
      .then(function(data) {
        let device = createRecord(data);
        return $q.resolve(device);
      });
  }

  function getAll(offset, limit) {
    return find({offset: offset, limit: limit});
  }

  function find(params) {
    let config = {};
    config.params = params;

    return doAaaGet(ORG_USER_PATH, config)
      .then(function(userCollection) {
        let userRecords;
        let userRecordsCollection;

        userRecords = _.map(userCollection.users, createRecord);
        userCollection.users = userRecords;
        userRecordsCollection = rnRecordCollectionFactory.create(userCollection);

        return $q.resolve(userRecordsCollection);
      });
  }

  function createRecord(data) {
    let user = rnRecordFactory.create(data);

    // JVM - hack - set id attribute for a consistent model.
    // This should be changed at the server.
    user.internal.idName = 'userId';
    return user;
  }

  function generate() {
    // TODO DJL - This method requests the model structure from the server. We need server-side implementation to support this
  }

  function getUserContext() {

    return doAaaGet(USER_CONTEXT_PATH);
  }

  function getSelectedUserOrgRoles(id) {
    // DJL - until we have the JSON/HAL design implemented on the server we will
    // have to perform this type of surgery
    let path = ORG_USER_PATH + id + '/roles';

    return doAaaGet(path);
  }

  function getSelectedUserRoles() {

    return doAaaGet(USER_ROLE_PATH, {params:{limit:1000}});
  }

  // Continue to call version 1 for backwards compatibility. Clients ideally should call getXSystemRoles instead.
  function getUserRoles(id) {
    let path = 'systemroles?' + id + 'Role=true';

    return doAaaGet(path, {version: 1});
  }

  function getUserSystemRoles(organizationType) {
    let path = 'systemroles?' + 'entityType=User' + '&organizationType=' + organizationType;
    if (organizationType === "HP") {
      // Tell the service to perform a check to see if the HP Operation role should be included in the list of roles returned
      path += '&hpOperationCheck=true';
    }

    return doAaaGet(path);
  }

  function getHmacSystemRoles(organizationType) {
    let path = 'systemroles?' + 'entityType=HMAC' + '&organizationType=' + organizationType;

    return doAaaGet(path, { cache: true });
  }

  function getDeviceSystemRoles(organizationType) {
    let path = 'systemroles?' + 'entityType=Device' + '&organizationType=' + organizationType;

    return doAaaGet(path);
  }

  function saveUserRoles(userID, roles) {
    let path = ORG_USER_PATH + userID + '/roles';

    return doAaaPost(path, roles);
  }


  /**
   * This function is a little tricky because of the AAA schema.  When we get called, we have the ID of the
   * system role (e.g. "Owner") and we have to go get all of the roles assigned to this user and check each one
   * for that ID.  Once we find it, the actual role ID we want to delete is userRoleId in that structure.
   */
  function removeUserRoles(userId, systemRoleId) {
    // The roleId passed in is the systemRoleId.  Get the roles for the user, then find the one that matches.
    return getSelectedUserOrgRoles(userId).then(function (userRoles) {
      angular.forEach(userRoles.userRoles, function(userRole, key) {
        if (userRole.systemRole.id === systemRoleId) {
          return doAaaDelete(ORG_USER_PATH + userId + '/roles/' + userRole.userRoleId);
        }
      });
    });
  }

  function removeUserAccount(accountId) {

    return doAaaDelete(USER_CONTEXT_PATH + accountId);
  }

  function deleteUser(userId) {
    return rnHttp.delete(AAA_SERVICE_NAME, ORG_USER_PATH + userId);
  }

  function updateUserProfile(userInfo) {
    return doAaaPut(USER_PATH, userInfo)
      .then(function() {
        return rnSession.updateUserInfo(userInfo);
      });
  }

  function validateUserToken() {
    let path = USER_PATH + 'validate';
    return doAaaGet(path, {});
  }

  function doAaaGet(path, config = {}) {

    return rnSession.isAuthenticated()
    .then(auth => {
      if (auth) {
        return rnHttp.get(AAA_SERVICE_NAME, path, config)
        .then(resp => {
          $log.debug('Successful ' + path + ' request: ', resp.data);
          return $q.resolve(resp.data);
        });
      } else {
        return $q.reject({status: 401, statusText: 'Unauthenticated'});
      }
    });
  }

  function doAaaPost(path, content) {
    return rnHttp.post(AAA_SERVICE_NAME, path, content);
  }

  function doAaaDelete(path) {
    return rnHttp.delete(AAA_SERVICE_NAME, path);
  }

  function doAaaDeleteWithContent(path, content) {
    return rnHttp.deleteWithBody(AAA_SERVICE_NAME, path, content);
  }

  function doAaaPut(path, content) {
    return rnHttp.put(AAA_SERVICE_NAME, path, content);
  }
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/user/user.service.js